import { LanguageOption } from "./ScorecardLanguageSelect.decl";

// en,es,fr,it,de,nl
export const SCORE_CARD_LANGUAGES: LanguageOption[] = [
  {
    languageCode: "en",
    name: "English",
    countryCode: "US",
  },
  {
    languageCode: "es",
    name: "Español",
    countryCode: "ES",
  },
  {
    languageCode: "fr",
    name: "Français",
    countryCode: "FR",
  },
  {
    languageCode: "it",
    name: "Italiano",
    countryCode: "IT",
  },
  {
    languageCode: "de",
    name: "Deutsch",
    countryCode: "DE",
  },
  {
    languageCode: "nl",
    name: "Nederlandse",
    countryCode: "NL",
  },
];
